// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { vmiAddProductModalStyles } from "@vanmeter/Overrides/Components/VmiAddProductModal";
import { createLinkIconStyles, hideEmpty, mergeWithCss, modalButtonsActionStyles } from "@vanmeter/XDL/Utilities";
import { css } from "styled-components";

vmiAddProductModalStyles.inputsContainer = {
    gap: 8,
};

vmiAddProductModalStyles.container = {
    gap: 12,
};

vmiAddProductModalStyles.titleText = {
    variant: "h6",
};

vmiAddProductModalStyles.buttonsGridItem = {
    ...mergeWithCss(modalButtonsActionStyles.buttonsGridItem, {
        css: css`
            &&& {
                margin-top: 16px;
            }
        `,
    }),
};

vmiAddProductModalStyles.errorGridItem = {
    width: 12,
    css: css`
        ${hideEmpty}
    `,
};

vmiAddProductModalStyles.importLink = {
    ...createLinkIconStyles({
        icon: "FilePlus",
        sizeVariant: "xsmall",
    }),
};

vmiAddProductModalStyles.cancelButton = {
    ...modalButtonsActionStyles.cancelButton,
};
